export default __webpack_public_path__ + "static/media/category_07.009fdf0c.png";